const PREFIX = 'traveldesk_booking_attribution_v1_';
const MAX_AGE = 72 * 60 * 60 * 1000;
const PARAMETERS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'gbraid', 'wbraid', 'td_campaign_id', 'td_adgroup_id', 'td_ad_id', 'td_device', 'td_network'];
const memory = new Map();
const SAFE_SLUG = /^[\p{L}\p{N}][\p{L}\p{N}-]{0,254}$/u;

function companyKey(companyId) {
  const id = Number(companyId);
  return Number.isInteger(id) && id > 0 ? PREFIX + id : '';
}

function read(key) {
  let saved = memory.get(key);
  try { saved = JSON.parse(window.sessionStorage.getItem(key)) || saved; } catch { /* Storage is optional. */ }
  return saved && Date.now() - Number(saved.captured_at) < MAX_AGE ? saved : {};
}

export function captureBookingAttribution(companyId, landing = {}) {
  if (typeof window === 'undefined') return {};
  const key = companyKey(companyId);
  if (!key) return {};
  const url = new URL(window.location.href);
  const incoming = {};
  PARAMETERS.forEach(name => {
    const value = url.searchParams.get(name)?.trim();
    if (value) incoming[name] = value.slice(0, 512);
  });
  const previous = read(key);
  const newCampaign = Object.keys(incoming).some(name => previous[name] !== incoming[name]);
  const data = newCampaign ? { ...incoming } : { ...previous, ...incoming };
  if (!data.utm_source && (data.gclid || data.gbraid || data.wbraid)) {
    data.utm_source = 'google';
    data.utm_medium = data.utm_medium || 'cpc';
  }
  let incomingSlug = '';
  try { incomingSlug = decodeURIComponent(url.pathname.split('/')[2] || '').toLowerCase(); } catch { /* Invalid URLs carry no landing context. */ }
  if (/^\/landing\/[^/]+\/?$/.test(url.pathname) && SAFE_SLUG.test(incomingSlug) && (!data.landing_slug || newCampaign)) {
    data.landing_slug = incomingSlug;
    data.landing_path = url.pathname;
    data.landing_url = url.origin + url.pathname;
  }
  // Native landing data can arrive after the first route event. Enrich the same entry landing.
  const nativeSlug = String(landing?.landing_keyword || '').trim().replace(/\s+/g, '-').toLowerCase();
  const landingId = Number(landing?.landing_id);
  if (Number(landing?.company_id) === Number(companyId) && Number.isInteger(landingId) && landingId > 0 && nativeSlug === data.landing_slug) {
    data.landing_id = landingId;
    data.landing_keyword = String(landing.landing_keyword).slice(0, 255);
    data.landing_campaign_code = 'LP-' + Number(companyId) + '-' + landingId;
    data.landing_campaign_name = data.landing_keyword;
  }
  data.captured_at = newCampaign || !data.captured_at ? Date.now() : data.captured_at;
  memory.set(key, data);
  try { window.sessionStorage.setItem(key, JSON.stringify(data)); } catch { /* Keep the memory copy. */ }
  const result = { ...data };
  delete result.captured_at;
  return result;
}

export function withBookingAttribution(booking, companyId, landing) {
  const existing = booking?.utmParams && typeof booking.utmParams === 'object' && !Array.isArray(booking.utmParams) ? booking.utmParams : {};
  return { ...booking, utmParams: { ...existing, ...captureBookingAttribution(companyId, landing) } };
}

export function bookingFunnelPageContext({ companyId, routeName, landing, locale }) {
  if (typeof window === 'undefined') return {};
  const attribution = captureBookingAttribution(companyId, landing);
  const hasLanding = SAFE_SLUG.test(attribution.landing_slug || '');
  const path = hasLanding ? '/landing/' + encodeURIComponent(attribution.landing_slug) : '/';
  const source = new URL(window.location.origin + path);
  PARAMETERS.forEach(name => { if (attribution[name]) source.searchParams.set(name, attribution[name]); });
  let referrer = null;
  try { referrer = new URL(document.referrer).origin; } catch { /* No referrer. */ }
  return { route_name: String(hasLanding ? 'landing-page' : routeName || '').slice(0, 120), route_path: path.slice(0, 2048), source_url: source.href.slice(0, 2048), referrer: referrer?.slice(0, 2048) || null, locale: locale === 'es' ? 'es' : 'en' };
}
